import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab, Breadcrumb } from 'react-bootstrap';
import './GHGEmissions.scss';
import CarbonEmissionDataContainer from '../CarbonEmission/CarbonEmissionDataContainer';

const GHGSettings = ({ t }) => {
  return (
    <div className='GHGInventory'>
      <div className="List_header mb-1">
        <div>
          <Breadcrumb className='h5'>
            <Breadcrumb.Item>{t("GHGEmissions.label")}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t("Settings.label")}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className='GHGInventory_btn_head'>

        </div>
      </div>
      <Tabs
        defaultActiveKey="calculator"
        id="uncontrolled-tab-example"
        className="GHGsettings-tab"
      >
        <Tab eventKey="calculator" title="Emission calculator">
          <div className='p-2'>
            <CarbonEmissionDataContainer />
          </div>
        </Tab>
        <Tab eventKey="upload" title="Upload emission factors">
          <div className='p-2'>
            
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};
export default withTranslation()(GHGSettings);